// 系统管理模块  部分接口
import request from '../request.js'

// 获取组织架构
export const getSysDept = function (data) {
    return request({
        url: 'sysDept/selectDeptTree',
        method: 'post',
        data
    })
}

// 新增组织架构
export const insertSysDept = function (data) {
    return request({
        url: 'sysDept/insert',
        method: 'post',
        data
    })
}

// 删除组织架构
export const  deleteSysDept = function (data) {
    return request({
        url: 'sysDept/deleteById',
        method: 'post',
        data
    })
}

// 获取组织架构信息
export const  getDeptInfo = function (data) {
    return request({
        url: 'sysDept/selectById',
        method: 'post',
        data
    })
}

// 获取用户组所属组织
export const  getGroupDepts = function (data) {
    return request({
        url: 'sysDept/selectGroupDepts',
        method: 'post',
        data
    })
}

//根据文件id预览文件
export const previewFile = function (data) {
    return request({
        url: 'sysFile/previewFile',
        method: 'post',
        data
    })
}
